import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CustomQuoteIcon from "./icons/custom-quote.component.jsx"

class Icon extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || '',
            value: this.props.value || '',
            style: this.props.style || {},
            size: this.props.size || '',
            iconText: this.props.iconText || '',
            marginBottom: this.props.marginBottom || "0px"
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            className: nextProps.className || '',
            value: nextProps.value || '',
            style: nextProps.style || '',
            iconText: nextProps.iconText || '',
        })
    }


    render() {
        const style = Object.assign({
            minWidth: '20px',
            display: 'inline-block',
        }, this.state.style)
        let icon = ''
        if (this.state.value.includes('cc-')) {
            icon = <FontAwesomeIcon icon={['fab', this.state.value]} style={{ width: this.state.size, height: this.state.size }} />
        } else {
            switch (this.state.value) {
                case 'quote':
                    icon = <CustomQuoteIcon />
                    break
                case 'invoice':
                    icon = <FontAwesomeIcon icon={'money-check-alt'} style={{ width: this.state.size, height: this.state.size }} />
                    break
                case 'order':
                    icon = <FontAwesomeIcon icon={'clipboard-list'} style={{ width: this.state.size, height: this.state.size }} />
                    break
                default:
                    icon = <FontAwesomeIcon icon={this.state.value} style={{ width: this.state.size, height: this.state.size, marginBottom: this.state.marginBottom }} />
            }
        }

        return <span className={"text-center " + (this.state.iconText ? 'position-relative ' : '') + this.state.className} style={style} >
            {icon}
            {this.state.iconText &&
                <span className="position-absolute" style={{
                    color: 'black',
                    fontSize: '0.9rem',
                    textShadow: '0.03rem 0rem black',
                    width: '100%',
                    left: '50%',
                    marginLeft: '-50%'
                }}>{this.state.iconText}</span>
            }
        </span>
    }
}

export default Icon


// WEBPACK FOOTER //
// ./src/common/icon/icon.component.jsx